export default __webpack_public_path__ + "static/media/10-gm-achieved.ce0ee03f.svg";